var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', {
    staticClass: "match-height"
  }, [_c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('tab-default')], 1), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('tab-icon')], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('tab-position')], 1), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('tab-filled')], 1), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('tab-justified')], 1), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('tab-alignment')], 1), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('tab-programmatically')], 1), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('tab-lazy')], 1), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('tab-dynamic')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }